function _templateObject() {
  var data = _taggedTemplateLiteral(["\n   font-size: 16px;\n   text-decoration: none;\n   display: inline-block;\n   padding: 0 1em;\n\n   line-height: ", ";\n\n   color: ", ";\n   border-bottom: 9px solid transparent;\n   border-top: 9px solid transparent;\n   transition: color 0.3s, border-color 0.3s;\n   background-color: transparent;\n   cursor: pointer;\n   outline: none;\n   border-right: none;\n   border-left: none;\n   text-align: left;\n\n   ", "\n\n   &:hover,\n   &:focus,\n   &:active {\n      outline: none;\n      color: ", ";\n      border-bottom-color: ", ";\n   }\n\n   &::after {\n      ", ";\n      position: absolute;\n      top: 35px;\n      right: 2em;\n      width: 0;\n      height: 0;\n      margin-left: 1rem;\n      border-left: 7px solid transparent;\n      border-right: 7px solid transparent;\n      border-top: 6px solid ", ";\n      clear: both;\n   }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled from 'styled-components';
import { math } from 'polished';
var TopNavMenuLink = styled.a(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return math("".concat(theme.sizes.siteHeaderHeight, " - 2 * 9px"));
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.brandColors.darkGray;
}, function (_ref3) {
  var submenuOpen = _ref3.submenuOpen,
      theme = _ref3.theme;
  return submenuOpen ? "\n      color: ".concat(theme.semanticColors.secondary, ";\n      border-bottom-color: ").concat(theme.semanticColors.secondary, ";\n   ") : '';
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.brandColors.lightBlue;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.brandColors.lightBlue;
}, function (_ref6) {
  var hasSubmenu = _ref6.hasSubmenu;
  return hasSubmenu ? "content: ''" : '';
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.brandColors.mediumLightGray;
});
export { TopNavMenuLink };